export default __webpack_public_path__ + "static/car_w.ce5987c332dd4656039dbb0f7e1ad720.svg";